module.exports = __webpack_public_path__ + "static/media/webdesign-services-img15.36a408f0.jpg";